module.exports = __webpack_public_path__ + "img/img5.64c55a83.jpg";